import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "play-circle",
  "use": "play-circle-usage",
  "viewBox": "0 0 25 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 25 24\" id=\"play-circle\"><path d=\"M12.334 22.75A10.75 10.75 0 1123.084 12a10.76 10.76 0 01-10.75 10.75zm0-20a9.25 9.25 0 109.25 9.25 9.26 9.26 0 00-9.25-9.25z\" /><path d=\"M11.023 17.23a2 2 0 01-2-2v-6a2 2 0 011.08-1.74 2 2 0 012.05.14l4.29 3a2 2 0 010 3.24l-4.29 3a2 2 0 01-1.13.36zm0-8.46a.51.51 0 00-.22.05.48.48 0 00-.26.43v6a.48.48 0 00.26.43.44.44 0 00.49 0l4.29-3a.47.47 0 000-.78l-4.25-3.04a.44.44 0 00-.31-.09z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol